import { useEffect } from 'react';

import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export default function FrontendObservability() {
  useEffect(() => {
    const { faroUrl, faroAppName, APP_ENV, APP_NAME, COMMIT_ID } = publicRuntimeConfig;

    if (!faroUrl || !['production', 'staging'].includes(APP_ENV)) return;

    try {
      initializeFaro({
        url: faroUrl,
        app: {
          name: faroAppName || APP_NAME || 'auth-front',
          version: COMMIT_ID || '1.0.0',
          environment: APP_ENV
        },
        instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()]
      });
    } catch (e) {
      console.error('[FrontendObservability] Faro init failed', e);
    }
  }, []);

  return null;
}
